<template>
  <div class="login-form">
    <b-row class="justify-content-md-center">
      <b-col class="home-col" lg="5" md="6">
        <div class="home-card login">
          <b-card header-tag="header">

            <h6 slot="header"
                class="mb-0">Acceso a la aplicación</h6>

            <b-form class="home-form">
              <b-form-group label="Nombre de usuario:" label-for="user">
                <b-form-input id="user" type="text" required v-model="username"
                              placeholder="Introduzca su nombre ..."
                ></b-form-input>
              </b-form-group>
            <!--  <b-form-group label="Contraseña:" label-for="password">
                <b-form-input id="password" type="password" v-model="password" required></b-form-input>
              </b-form-group>-->
               <!-- <b-form-group label="Contraseña" label-for="password">
                <b-input-group class="pass-group">
                  <b-form-input :type="type" v-model="password" @keydown.enter.native="doLogin" required></b-form-input>
                  <b-input-group-addon slot="">
                    <b-btn :variant="'outline-secondary'" size="sm" v-on:click="togglePassword()">
                      <i v-if="type == 'password'" class="fa fa-eye" aria-hidden="true"></i>
                      <i v-if="type == 'text'" class="fa fa-eye-slash" aria-hidden="true"></i>
                    </b-btn>
                  </b-input-group-addon>
                </b-input-group>
              </b-form-group> -->
              <b-form-group label="Contraseña" label-for="password">
                <b-input-group class="pass-group">
                  <b-form-input :type="type" v-model="password" @keydown.enter.native="doLogin" required></b-form-input>

                   <b-input-group-addon class="icon-pw" slot="right">
                     <i v-if="type == 'password'" v-on:click="togglePassword()" class="fa fa-eye" aria-hidden="true"></i>
                     <i v-if="type == 'text'" v-on:click="togglePassword()" class="fa fa-eye-slash" aria-hidden="true"></i>

                   </b-input-group-addon>
                </b-input-group>
              </b-form-group>
            </b-form>

          </b-card>
        </div>
        <button v-on:click="doLogin" type="button" class="btn btn-primary-linear btn-block login-button" :disabled="loading">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw" aria-hidden="true" v-if="loading"></i>
          <span v-if="!loading">Acceder</span></button>
      </b-col>
    </b-row>
    <b-row class="errors">
      <b-col>
        <b-alert :show="error" variant="danger">
          {{errorMsg}}
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        type: 'password',
        username: '',
        password: '',
      };
    },
    computed: {
      ...mapGetters({
        loading: 'isLogging',
        error: 'loginError',
        errorMsg: 'loginErrorMsg',
      }),
    },
    mounted() {
      this.$store.commit('PERFORMING_LOGIN', false);
    },
    methods: {
      doLogin() {
        this.$store.dispatch('loginAction', { username: this.username, password: this.password });
      },
      togglePassword() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "../../theme/nexum-bootstrap";
  @import "../../../node_modules/bootstrap/scss/bootstrap.scss";
  .home-col {
    .home-card.login {
      .card{
        margin-top: -42px;
        border-radius: 0;
        border-radius: 5px;
        .card-header {
          background-color: $headers-blue;
          color: white;
          text-align: left;
          padding-left: 20px;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
        .card-body{
          background-color: #f3f3f3;
          .home-form {
            text-align: left;
          }
          @include media-breakpoint-only(xs) {
            padding-top: 5px;
            padding-bottom: 5px;
          }
        }
      }
      &:after{
        @include nexum-shadow-border("../../assets");
      }
    }
    .login-button {
      margin-top: 5vh;
      border-radius: 5px;
      min-height: 60px;
    }
  }
  .errors {
    margin-top: 1vh;
  }
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #35495E;
  }
  @include media-breakpoint-only(xs) {
    legend {
      span {
        font-size: 0.9rem;
      }
    }
  }
  .icon-pw {
    position: absolute;
    right: 10px;
    top: 6px;
    z-index: 20;
  }
</style>



// WEBPACK FOOTER //
// src/features/login/Login.container.vue